const TRANSITION_MS = 350;

let isSidebarTransitioning = false;
let fallbackTimer: ReturnType<typeof setTimeout> | null = null;
let transitionEndListenerAttached = false;

const listeners = new Set<() => void>();

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

const endTransition = () => {
  if (fallbackTimer) {
    clearTimeout(fallbackTimer);
    fallbackTimer = null;
  }

  if (!isSidebarTransitioning) {
    return;
  }

  isSidebarTransitioning = false;
  emitChange();
};

const handleTransitionEnd = (event: TransitionEvent) => {
  const page = document.getElementById('page');
  if (page && event.target === page && event.propertyName === 'left') {
    endTransition();
  }
};

const ensureTransitionEndListener = () => {
  if (transitionEndListenerAttached) {
    return;
  }

  transitionEndListenerAttached = true;
  document.addEventListener('transitionend', handleTransitionEnd);
};

export const beginSidebarTransition = (): void => {
  ensureTransitionEndListener();

  if (fallbackTimer) {
    clearTimeout(fallbackTimer);
  }

  if (!isSidebarTransitioning) {
    isSidebarTransitioning = true;
    emitChange();
  }

  fallbackTimer = setTimeout(endTransition, TRANSITION_MS);
};

export const subscribeToSidebarTransition = (callback: () => void): (() => void) => {
  ensureTransitionEndListener();
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
};

export const getSidebarTransitionSnapshot = (): boolean => isSidebarTransitioning;
